import * as types from '../actions/types';
const initState = {
  isAdmin: false,
  firstName: '',
  availability: '',
  loggedIn: false,
  mfaToken: '',
  phoneNumberLastDigits: '',
  id: '',
  expertToggleLockConfirmation: false,
  availabilitySwitchLockExp: false,
  expertName: '',
  expertClass: '',
  expertType: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case types.UPDATE_EXPERT_TOGGLE_LOCK_CONFIRMATION:
      return {
        ...state,
        expertToggleLockConfirmation: action.value,
      };
    case types.UPDATE_AVAILABILITY_SWITCH_LOCK_EXP:
      return {
        ...state,
        availabilitySwitchLockExp: action.value,
      };
    case types.CHANGE_LOGIN_STATUS:
      return {
        ...state,
        loggedIn: action.isLoggedIn,
      };
    case types.UPDATE_USER:
      return {
        ...state,
        ...action.user,
      };

    case types.SET_MFA_INFORMATION:
      return {
        ...state,
        mfaToken: action.mfaToken,
        phoneNumberLastDigits: action.phoneNumberLastDigits,
      };
    default:
      return state;
  }
};
